import { render, staticRenderFns } from "./UploadFilePreIngreso.vue?vue&type=template&id=41619879"
import script from "./UploadFilePreIngreso.vue?vue&type=script&lang=js"
export * from "./UploadFilePreIngreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports